import React from 'react';
import { Page } from '../Page';
export function PageGLP1Overview3() {
  return <Page pageNumber={4} variant="light" data-id="element-1409" data-mp="3js0yjeg5jltl">
      <div className="flex flex-col h-full" data-id="element-1410" data-mp="3jt2lag6j5wr5">
        {/* Two Column Layout */}
        <div className="grid grid-cols-2 gap-10 mt-6" data-id="element-1411" data-mp="1mehqur4phnl">
          {/* Left Column - The Brain Effect */}
          <div data-id="element-1412" data-mp="3sreacdrr0mhh">
            <h2 className="text-2xl font-serif text-[#1F1F1F] leading-tight mb-2" data-id="element-1413" data-mp="3srnxzupbmhk0">
              The Brain Effect
            </h2>
            <div className="w-10 h-0.5 bg-tealslate mb-4" data-id="element-1414" data-mp="bhzeoehcbrqh" />
            <p className="text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-1415" data-mp="6kg0fekn7eyj">
              At the same time, this medication is working on your brain. It
              communicates directly with the areas that control hunger,
              cravings, and reward. What most people describe as "food noise"
              starts to quiet down. You're not constantly thinking about what to
              eat next, and cravings don't feel as intense or urgent.
            </p>
            <p className="text-sm text-[#3B3B3B] leading-[1.8] mt-4" data-id="element-1416" data-mp="3czunh7sqzxr7">
              This isn't about forcing discipline. It's a real change in how
              your brain responds to food. Tirzepatide tends to have a slightly
              stronger effect here because it works on more than one pathway,
              but both medications play a role in reducing that constant pull
              toward food.
            </p>
          </div>

          {/* Right Column - The Result */}
          <div data-id="element-1417" data-mp="3vwmclxuz1736">
            <h2 className="text-2xl font-serif text-[#1F1F1F] leading-tight mb-2" data-id="element-1418" data-mp="4rw5bp4gbl8n">
              The Result
            </h2>
            <div className="w-10 h-0.5 bg-tealslate mb-4" data-id="element-1419" data-mp="9jxbquexuhqr" />
            <p className="text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-1420" data-mp="ehz5c99zpzgh">
              When you combine these two effects, things start to feel different
              in a very practical way. You're physically fuller, and mentally,
              food just isn't as loud. That combination makes it easier to eat
              less without feeling like you're fighting yourself all day.
            </p>
            <p className="text-sm text-[#3B3B3B] leading-[1.8] mt-4" data-id="element-1421" data-mp="2jjfnrs1vpfjh">
              The calorie deficit happens more naturally, without relying on
              willpower alone. The medication is doing that part for you, which
              shifts your role. Instead of trying to force yourself to eat less,
              your focus moves toward supporting your body with the right
              nutrition, habits, and structure to get the best results possible.
            </p>
          </div>
        </div>

        {/* Patient Quote */}
        <div className="flex-1 flex items-center justify-center px-8" data-id="element-1422" data-mp="3capenhpykacm">
          <div className="text-center" data-id="element-1423" data-mp="37bmas0lpsa68">
            <p className="text-2xl font-serif text-[#1F1F1F] leading-relaxed" data-id="element-1424" data-mp="37cnzv8zkex6y">
              "For the first time, I'm not reacting to food. I'm actually
              thinking about what my body needs."
            </p>
            <p className="text-sm text-[#6B6B6B] mt-5 tracking-wide uppercase" data-id="element-1425" data-mp="1cz68tbzybi76">
              — GLP-1 User
            </p>
          </div>
        </div>
      </div>
    </Page>;
}